import { render, staticRenderFns } from "./BannerEditDialog.vue?vue&type=template&id=81058ca8&scoped=true"
import script from "./BannerEditDialog.vue?vue&type=script&lang=js"
export * from "./BannerEditDialog.vue?vue&type=script&lang=js"
import style0 from "./BannerEditDialog.vue?vue&type=style&index=0&id=81058ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81058ca8",
  null
  
)

export default component.exports